import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../Grid';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

export default function ModalContainer({
  className,
  children,
  ...props
}) {
  const classes = useStyles();
  const clsMain = makeClassName([
    className,
    classes[mainCls],
    'is-over--a',
  ]);

  return (
    <Grid className={clsMain} direction="column" { ...props }>
      { children }
    </Grid>
  );
};

ModalContainer.propTypes = {
  /**
   * Component class
   */
  className: PropTypes.string,
};

ModalContainer.defaultProps = {
  className: '',
};
